import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { useLocation } from 'react-router-dom';

const PrivateRoute = () => {
    let isLoggedIn = localStorage.getItem('isLoggedIn');
    let token = localStorage.getItem('Token');
    const location = useLocation();
    let auth;

    if((token == null || token == '') && (isLoggedIn == null || isLoggedIn == '')) {
        auth = false;
    }
    else if(isLoggedIn && token !== null){
        let decode = jwt_decode(token);
        if(!decode){
            auth = false;
        }
        else if(decode.userType == 'admin'){
            auth = true;
        }
        else if(decode.userType == 'user'){
            auth = true;
        }
        else{
            auth = false;
        }
    }
    else if(isLoggedIn && (token == null || token == '')){
        auth = false;
    }
    else{
        auth = false
    }
    localStorage.setItem("pathAfterLogin",JSON.stringify(location))
    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return auth ? <Outlet /> : <Navigate to="/" replace={true} />;
}

export default PrivateRoute;